import { PermissionsView } from '@app/modules/admin/components/permission/view/PermissionsView';
import { UserStationPermissionItem } from '@app/modules/admin/components/stations-permissions/UserStationPermissionItem';
import { UserPermissionForStationState } from '@app/modules/admin/types';
import { User } from '@mi-front/core';
import { AsyncView, NullState } from '@mi-front/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { fetchUserPermissionsForAll } from '../../../../api/permissions';

interface Props {
  readonly user: User;
}

export const UserPermissionsManager = ({ user }: Props) => {
  const { $t } = useIntl();

  return (
    <AsyncView promiseFn={() => fetchUserPermissionsForAll(user.id)}>
      {(vp) => {
        const permissionsState = vp.data;

        return (
          <PermissionsView
            permissionsState={permissionsState}
            canModify={() => true}
            filterFn={(pState, text) => {
              return !!pState.station.name.match(new RegExp(text, 'i'));
            }}
            emptyListMsg={
              <NullState>
                <FormattedMessage
                  id="admin.users.viewScreen.permissions.noFilterMatch"
                  defaultMessage="No se encontraron emisoras coincidentes"
                />
              </NullState>
            }
            filterPlaceholder={$t({
              id: 'admin.users.viewScreen.permissions.filterPlaceholder',
              defaultMessage: 'Filtrar emisoras',
            })}
            PermissionItemComponent={({
              permissionState,
            }: {
              permissionState: UserPermissionForStationState;
            }) => <UserStationPermissionItem permissionState={permissionState} user={user} />}
          />
        );
      }}
    </AsyncView>
  );
};
